import React, { useState } from 'react'
import CountUp from 'react-countup';
import ScrollTirgger from 'react-scroll-trigger';
import smallLogo from '../images/logo-small.png'
import shop from '../images/shop2.png'
import agency from '../images/agency2.png'
import package2 from '../images/package2.png'
import smallLogo1 from '../images/logo-small1.png'
import shop1 from '../images/shop1.png'
import agency1 from '../images/agency1.png'
import employe from '../images/employees_01.png'
import employe1 from '../images/employees_02.png'
import package1 from '../images/package1.png'
import { useLang } from "./Provider/LanguageProvider";

export default function FactsCTA() {
  const { language } = useLang();

  const [isHovered, setIsHovered] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [isHovered3, setIsHovered3] = useState(false);
  const [isHovered4, setIsHovered4] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const handleMouseEnter1 = () => {
    setIsHovered1(true);
  };

  const handleMouseLeave1 = () => {
    setIsHovered1(false);
  };
  const handleMouseEnter2 = () => {
    setIsHovered2(true);
  };

  const handleMouseLeave2 = () => {
    setIsHovered2(false);
  };
  const handleMouseEnter3 = () => {
    setIsHovered3(true);
  };

  const handleMouseLeave3 = () => {
    setIsHovered3(false);
  };

  const handleMouseEnter4 = () => {
    setIsHovered4(true);
  };

  const handleMouseLeave4 = () => {
    setIsHovered4(false);
  };

  const [counterOn, setCounterOn] = useState(false);
  return (
    <ScrollTirgger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
      <section className='fact-section'>
        <div className='container'>
          <div className='fact' data-aos="zoom-out-up" onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}>
            {isHovered ? <img src={smallLogo1} alt='small logo' /> : <img src={smallLogo} alt='small logo' />}
            <div className='fact-number'>
              <span className='num'>
                {counterOn && <CountUp start={0} end={30} duration={2} delay={0} />}
              </span>
            </div>
            <h1>
              {language === 'fr' ? "ANNÉES D'EXISTENCES" : 'YEARS'}
            </h1>
          </div>
          <div className='fact package-cont' data-aos="zoom-out-up" onMouseEnter={handleMouseEnter4}
            onMouseLeave={handleMouseLeave4}>
            {isHovered4 ? <img src={employe} alt='small logo' /> : <img src={employe1} alt='small logo' />}
            <div className='fact-number'>
              <span className='num'>
                {counterOn && <CountUp start={0} end={380} duration={3} delay={0} />}
              </span>
              <span className='plussign'>
                +
              </span>
            </div>
            <h1>
              {language === 'fr' ? 'EMPLOYÉS' : 'EMLPOYEES'}
            </h1>
          </div>
          <div className='fact package-cont' data-aos="zoom-out-up" onMouseEnter={handleMouseEnter1}
            onMouseLeave={handleMouseLeave1}>
            {isHovered1 ? <img src={package1} alt='small logo' /> : <img src={package2} alt='small logo' />}
            <div className='fact-number'>
              <span className='num'>
                {counterOn && <CountUp start={0} end={4} duration={3} delay={0} />}
              </span>
            </div>
            <h1>
              {language === 'fr' ? 'MARQUES DISTRIBUÉES' : 'DISTRIBUTED BRANDS'}
            </h1>
          </div>
          <div className='fact' data-aos="zoom-out-up" onMouseEnter={handleMouseEnter2}
            onMouseLeave={handleMouseLeave2}>
            {isHovered2 ? <img src={shop1} alt='small logo' /> : <img src={shop} alt='small logo' />}
            <div className='fact-number'>
              <span className='num'>
                {counterOn && <CountUp start={0} end={20} duration={2} delay={0} />}
              </span>
              <span className='plussign'>
                +
              </span>
            </div>
            {language === 'fr' ? <h1>
              AGENCES ACTIFS
              DONT 27 ENTREPÔTS
              SECONDAIRES
            </h1> : <h1>
              ACTIVE AGENCIES
              INCLUDING 27
              SECONDARY WAREHOUSES
            </h1>}
          </div>
          <div className='fact' data-aos="zoom-out-up" onMouseEnter={handleMouseEnter3}
            onMouseLeave={handleMouseLeave3}>
            {isHovered3 ? <img src={agency1} alt='small logo' /> : <img src={agency} alt='small logo' />}
            <div className='fact-number'>
              <span className='num'>
                {counterOn && <CountUp start={0} end={40} duration={2} delay={0} />}
              </span>
              <span className='plussign'>
                +
              </span>
            </div>
            {language === 'fr' ?
              <h1>
                POINTS DE VENTE
                DANS 17 PROVINCES
              </h1> : <h1>
                SALE POINTS IN 17 PROVINCES
              </h1>}
          </div>
        </div>
      </section>
    </ScrollTirgger>
  )
}
